export interface SlugLanguageConfig {
  readonly digraphs: Readonly<Record<string, string>>;
  readonly stopWords: ReadonlySet<string>;
}

// Words first, stop words dropped, then transliterated -- so raw stop words
// ("och", "für") are matched before their diacritics fold to ASCII.
export function slugifySegment(segment: string, config: SlugLanguageConfig): string {
  const tokens = segment
    .toLowerCase()
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean);
  const kept = tokens.filter((token) => !config.stopWords.has(token));
  const source = kept.length > 0 ? kept : tokens;
  return source
    .map((token) => transliterate(token, config.digraphs))
    .filter(Boolean)
    .join('-');
}

function transliterate(token: string, digraphs: Readonly<Record<string, string>>): string {
  let mapped = '';
  for (const char of token) {
    mapped += digraphs[char] ?? char;
  }
  return mapped
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}
